import { configureStore } from '@reduxjs/toolkit'
import authReducer from './auth/authSlice'
import offersReducer from './offers/offersSlice'
import confirmationModalReducer from './ui/confirmationModalSlice'
import fillPONumberModalReducer from './ui/fillPONumberModalSlice'
import loadingOverlayReducer from './ui/loadingOverlaySlice'
import uiReducer from './ui/uiSlice'
import tableReducer from './ui/tableSlice'
import offerModalReducer from '@/features/offers/slices/offerModal.slice'

import offerDetailsReducer from '@/features/offers/slices/offerDetail.slice'
import modalReducer from './ui/modalSlice'

const createStore = () => {
  const thunkArguments = {}
  const store = configureStore({
    reducer: {
      modal: modalReducer,
      table: tableReducer,
      ui: uiReducer,
      offers: offersReducer,
      offerDetail: offerDetailsReducer,
      auth: authReducer,
      loadingOverlay: loadingOverlayReducer,
      confirmationModal: confirmationModalReducer,
      fillPONumberModal: fillPONumberModalReducer,
      offerModal: offerModalReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: thunkArguments,
        },
      }),
  })

  thunkArguments.store = store

  return store
}

const store = createStore()

export default store
